import React, { createContext, useContext } from "react";

export const CurrentPathContext = createContext<string | null>(null);

export type CurrentPathProviderProps = {
  currentPath: string;
  children: React.ReactNode;
};

export const CurrentPathProvider: React.FC<CurrentPathProviderProps> = ({
  currentPath,
  children,
}) => (
  <CurrentPathContext.Provider value={currentPath}>
    {children}
  </CurrentPathContext.Provider>
);
